<script>
    import { onMount } from "svelte";
    import {client} from "./apiClient";


    export let token;
    let userId;
    //All errors object.
    let errors = {};
  
    function openForm() {

        
        Fidel.openForm({
            companyName: client.isponsorus.companyNameIsponsorUs,
            sdkKey: client.isponsorus.sdkKeyIsponsorUs,
            programId: client.isponsorus.programIdUs,
            callback() {
                console.log(arguments);

                let [err,success] = [...arguments];

                if(success){
                    console.log(success);

                    console.log(success.id);

                     client.registerFidel(success);

                    if(MobileApp){
                        MobileApp.postMessage("success");                   
                    }

                }
            },
            metadata: {
                myUserId: userId,
            },
            closeOnSuccess : false,
            custom :{
                title:{
                    style : {
                        display: 'none',
                    }
                },
                close: {
                    location: 'overlay'
                },
                overlay: {
                            style: {
                            background: "#fff"
                            }
                        },
                        form: {
                                style: {
                               
                             position: 'absolute',
                                top: 0,
                                bottom : 0,
                                left: 0,   
                               

                                }
            }
    }});
    }

    onMount(() => {
       
            client.getProfile(token).then((response) => {
                if (response.status === 200) {
                    return response.json();
                } else {
                    throw new Error("something went wrong");
                }
            })
            .then((data) => {
                userId = data.userId;
                console.log(userId);
          

        openForm();
            })
            .catch((error) => {
                errors = { response: error };
            });
        
    });
</script>



<style>
    body {
        font-family: sans-serif;
        padding: 30px;
        color: #111;
    }

    h1 {
        font-size: 24px;
    }

    button {
        height: 34px;
        font-size: 16px;
        font-weight: 500;
        border: 1px solid #111;
        color: white;
        background: #111;
        box-shadow: 0px 0px 4px 2px #ddd;
        cursor: pointer;
        margin: 30px 0 20px;
    }
</style>
